/**
 * Revenue Recognition RTK Query tag-type registry (revenueRecognition module).
 *
 * Mirrors the claims module pattern (`modules/claims/data/tags.ts`): all tag types are declared
 * up-front here and passed to the single base `createApi` (see `revenueRecognitionApi.ts`).
 * `injectEndpoints` cannot introduce new tag types, so any tag a feature endpoint provides or
 * invalidates MUST be listed here.
 */
export const REVENUE_RECOGNITION_TAG_TYPES = [
  'CenterSummary',
  'AccountingServiceSummary',
  'CenterPeriodFigures',
  'AccountLookup',
  'PeriodAccounts',
  'AccountDetail',
  'PeriodStatus',
] as const;

export type RevenueRecognitionTagType = (typeof REVENUE_RECOGNITION_TAG_TYPES)[number];
